import template from './sw-first-run-wizard.html.twig';

/**
 * @package services-settings
 * @private
 */
export default {
    template,
};
